import { QueryFunction, useQuery } from '@tanstack/react-query';
import { createAxiosInstance } from 'api/request';
import { QueryHook } from 'utils/hooks/queries/types';

type RequestReturnType = number;

const request: QueryFunction<RequestReturnType> = async ({ signal }) =>
{
  const response = await createAxiosInstance().get('/feed/unseenFeedItemCount', { signal });
  return response.data;
};

export const BASE_QUERY_KEY = 'notificationCount';

const useNotificationCountQuery: QueryHook<RequestReturnType> = () =>
{
  return useQuery({
    queryKey: [BASE_QUERY_KEY],
    queryFn: request,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: false,
  });
};

export default useNotificationCountQuery;